import { centsToFormattedDollars } from '@fruitful/fruitils';
import React from 'react';
import Animated, { FadeInDown } from 'react-native-reanimated';
import { BodySmallRegular, XStack, YStack } from 'smoothie';

import { type IncomeSplitExecution } from '../types/IncomeSplitOverviewTypes';

export const IncomeSplitExecutionDetails = ({
    execution,
}: {
    execution: IncomeSplitExecution;
}) => {
    const { amount, description, date, sourceAccountName } = execution;

    return (
        <Animated.View entering={FadeInDown.duration(250)}>
            <YStack gap={12} padding={16} flexShrink={1}>
                <XStack
                    alignItems="center"
                    justifyContent="space-between"
                    gap={8}
                >
                    <BodySmallRegular color="$gray1000">
                        Amount
                    </BodySmallRegular>
                    <BodySmallRegular>
                        {centsToFormattedDollars(amount)}
                    </BodySmallRegular>
                </XStack>
                <XStack
                    alignItems="center"
                    justifyContent="space-between"
                    gap={8}
                >
                    <BodySmallRegular color="$gray1000">
                        Description
                    </BodySmallRegular>
                    <BodySmallRegular numberOfLines={1} flexShrink={1}>
                        {description}
                    </BodySmallRegular>
                </XStack>
                <XStack
                    alignItems="center"
                    justifyContent="space-between"
                    gap={8}
                >
                    <BodySmallRegular color="$gray1000">Date</BodySmallRegular>
                    <BodySmallRegular>{date}</BodySmallRegular>
                </XStack>
                <XStack
                    alignItems="center"
                    justifyContent="space-between"
                    gap={8}
                >
                    <BodySmallRegular color="$gray1000">
                        Account
                    </BodySmallRegular>
                    <BodySmallRegular numberOfLines={1} flexShrink={1}>
                        {sourceAccountName}
                    </BodySmallRegular>
                </XStack>
            </YStack>
        </Animated.View>
    );
};
